import { render, staticRenderFns } from "./CompetitionDetailsView.vue?vue&type=template&id=2725b68a"
import script from "./CompetitionDetailsView.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports